import { Organization } from "chq";
import { StoryQuestion } from "components/stories/post-stories-v2/types";

const showUnsplashImageFinder = (
  organization: Organization | Partial<Organization>,
  selectedPrompt: StoryQuestion | null | undefined
) => (organization?.unsplashImages && selectedPrompt?.allowedTypes !== "just_videos");

export default showUnsplashImageFinder;
